export enum DrawerType {
  Info,
  CompanyData,
}
